export default __webpack_public_path__ + "static/media/lap_image5.619c9ce9.jfif";